
function DevProject({
    projectData,
    inverted    
}) {

    const projectID = "moreSection".concat(projectData.projectName.replaceAll(' ', ''));
    

    const handleMoreClick = () => {
        const moreSection = document.getElementById('moreSection'.concat(projectID));    
        const moreButton = document.getElementById('moreButton'.concat(projectID));
        
        if(moreSection.classList.contains('moreHidden')){
            moreSection.classList.remove('moreHidden');
            moreSection.style = '';
        
            if(window.innerWidth > 650){
                var height = 0;
                Array.prototype.forEach.call(moreSection.children, element => {
                    height += element.clientHeight;
                    
                    var style = element.currentStyle || window.getComputedStyle(element);
                    height += parseInt(style.marginTop);     
                });
                moreSection.style.height = height + 'px';              
            }            
            else{
                moreSection.style.height = 'fit-content'; 
            }                                   
        
            moreButton.innerHTML = 'Less';
        }
        else{            
            moreSection.style = 'margin: 0';
            moreSection.classList.add('moreHidden');
            moreButton.innerHTML = 'More';
        }
    }    

    return(
        <>        
            <div className={inverted ? "projectContainer inverted" : "projectContainer"}>
                <div className="projectContainerContent">
                    <div className="projectContainerContentLeft">
                        <img src={projectData.logo} alt="Healthy break app logo" />
                    </div>
                    <div className="projectContainerContentRight">
                        <h1>{projectData.projectName}</h1>
                        {projectData.description}
                    </div>                            
                    <div style={{clear:'both'}}/>
                </div>  

                <div className='projectMoreButtonContainer'>
                    <button onClick={handleMoreClick} id={'moreButton'.concat(projectID)}>More</button>   
                </div>

                <div className="projectContainerContent moreSection moreHidden" style={{margin: '0'}} id={'moreSection'.concat(projectID)}>
                    <div className='projectScreenshotsContainer'>
                        {projectData.screenShots.map(screenshot => {
                            return <img src={screenshot} alt='screenshot'/>
                        })}
                    </div>
                    <div className='projectStoreLinksContainer'>
                        {projectData.storeLinks.map(linkData => {
                            return <a href={linkData[1]} className='projectStoreLink'>{linkData[0]}</a>
                        })}
                    </div>
                </div>
            </div>          
        </>
    );

}

export default DevProject;